<script setup lang="ts">
import {toRef} from 'vue'
import CreateUser from '@/components/system/CreateUser.vue'
import useEnvironmentStore from '@/stores/environmentStore'
useEnvironmentStore().setContextId(6)
const logo = '/logo-darkened-300x167.png'

const props = defineProps({
  campaignCode: String
})

const campaignCode = toRef(props, 'campaignCode')
</script>

<template>
  <div class="logo">
    <img :src="logo" />
  </div>
  <div class="content-wrapper">
    <div class="content-item">
      <h1>{{ $t('new-user.title') }}</h1>
      <p>
        {{ $t('new-user.instruction1') }}
      </p>
      <p>
        {{ $t('new-user.instruction2') }}
      </p>
    </div>
    <div class="content-item">
      <CreateUser :campaignCode="campaignCode"></CreateUser>
    </div>
  </div>
</template>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
}

.content-item {
  margin-top: 8px;
}

.logo {
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 16px;
}

p {
  margin-top: 8px;
}
</style>
